import apiClient from '../api/apiClient';

const BASE = '/api/v1/admin/pricing-groups';

/**
 * @param {object} [params]
 * @param {string} [params.search]
 * @returns {Promise<Array<{ id: string, group_name: string, description: string | null, created_at, updated_at }>>}
 */
async function getListResponse(params = {}) {
  const response = await apiClient.get(BASE, { params });
  const body = response?.data;
  if (body?.success === false) {
    const msg = body?.message;
    throw new Error(typeof msg === 'string' ? msg : 'Failed to load pricing groups');
  }
  const data = body?.data;
  const list = data?.pricingGroups;
  return Array.isArray(list) ? list : [];
}

const pricingGroupService = {
  list: (params) => getListResponse(params),

  getByUuid: async (uuid) => {
    const response = await apiClient.get(`${BASE}/${uuid}`);
    const body = response?.data;
    if (body?.success === false) {
      const msg = body?.message;
      throw new Error(typeof msg === 'string' ? msg : 'Failed to load pricing group');
    }
    return body?.data?.pricingGroup ?? null;
  },

  create: async (payload) => {
    const response = await apiClient.post(BASE, payload);
    return response?.data;
  },

  update: async (uuid, payload) => {
    const response = await apiClient.patch(`${BASE}/${uuid}`, payload);
    return response?.data;
  },

  remove: async (uuid) => {
    const response = await apiClient.delete(`${BASE}/${uuid}`);
    return response?.data;
  },
};

export default pricingGroupService;
